import { Link } from 'react-router-dom';
import { Seo, SITE_URL } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';

export default function Felix() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'Über Felix – der Feinschmecker hinter Felix Genuss',
    description: 'Felix ist ein Bolonka Zwetna und der Namensgeber von Felix Genuss.',
    inLanguage: 'de',
    isPartOf: { '@id': `${SITE_URL}/#website` },
  };

  return (
    <>
      <Seo
        title="Über Felix | Der Feinschmecker hinter Felix Genuss"
        description="Felix ist ein Bolonka Zwetna, Namensgeber und Feinschmecker hinter Felix Genuss. Lerne den kleinen Hund hinter der Marke kennen."
        path="/felix"
        jsonLd={jsonLd}
      />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Über Felix' }]} />

      <div className="container-site mt-10 grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="eyebrow">Der Feinschmecker</p>
          <h1 className="mt-3 font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
            Hallo, ich bin Felix
          </h1>
          <hr className="gold-rule mt-6" />
          <p className="mt-6 leading-relaxed text-brand-brown/85">
            Ich bin Felix, ein Bolonka Zwetna und der Namensgeber von Felix Genuss. Gutes Essen gehört für mich zu einem schönen Hundeleben einfach dazu.
          </p>
          <p className="mt-4 leading-relaxed text-brand-brown/85">
            Felix Genuss ist aus der Idee entstanden, hochwertige Rezepte, sorgfältig ausgewählte Zutaten und die Freude am Kochen auch für Hunde zusammenzubringen.
          </p>
          <p className="mt-4 leading-relaxed text-brand-brown/85">
            Diese Seite wächst gemeinsam mit Felix Genuss. Bald gibt es hier noch mehr über Felix und die Geschichte hinter der Marke zu entdecken.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/rezepte/haehnchen-quinoa-bowl" className="btn-primary" data-testid="felix-cta-rezept">
              Felix' Lieblingsrezept
            </Link>
            <Link to="/wissen" className="btn-secondary" data-testid="felix-cta-wissen">
              Zum Wissensbereich
            </Link>
          </div>
        </div>
        <figure>
          <img
            src="/assets/brand/felix-testet-1280.webp"
            srcSet="/assets/brand/felix-testet-800.webp 800w, /assets/brand/felix-testet-1280.webp 1280w, /assets/brand/felix-testet-1600.webp 1600w"
            sizes="(min-width: 1024px) 50vw, 100vw"
            width="1280"
            height="714"
            alt="Felix, ein heller Bolonka Zwetna mit langen Ohren, schaut freundlich in die Kamera"
            fetchPriority="high"
            className="h-auto w-full border border-brand-gold/30"
            data-testid="felix-portrait"
          />
          <figcaption className="mt-3 text-sm text-brand-brown-soft">Felix – Namensgeber, Chefverkoster und Herz von Felix Genuss.</figcaption>
        </figure>
      </div>

      <section className="container-site mt-20 max-w-3xl" aria-labelledby="felix-aufgaben">
        <h2 id="felix-aufgaben" className="font-serif text-2xl font-bold sm:text-3xl">Felix' Aufgaben bei Felix Genuss</h2>
        <ul className="mt-6 list-disc space-y-2 pl-6 leading-relaxed text-brand-brown/90 marker:text-brand-gold">
          <li>Jedes neue Rezept höchstpersönlich probieren</li>
          <li>Mit wachem Blick über die Zutatenauswahl wachen</li>
          <li>Für gute Laune in der Küche sorgen</li>
        </ul>
        <p className="mt-6 text-sm leading-relaxed text-brand-brown-soft">
          Was „geprüft“ bei uns bedeutet: Felix hat das Rezept probiert und für gut befunden. Es ist keine tiermedizinische oder wissenschaftliche Prüfung. Kleine Geschichten aus unserem Alltag findest du im{' '}
          <Link to="/magazin" className="link-inline">Magazin</Link>.
        </p>
      </section>
    </>
  );
}
